import { Link, useLocation } from 'react-router-dom'
import { Icon } from '@ztechapps/webui.util'
import { menuItems } from './menuData'

const AppMenu = () => {
  const { pathname } = useLocation()

  return (
    <ul className="side-nav">
      {menuItems.map((item) => {
        const isActive = pathname.startsWith(item.url)

        return (
          <li key={item.slug} className={`side-nav-item${isActive ? ' active' : ''}`}>
            <Link to={item.url} className={`side-nav-link${isActive ? ' active' : ''}`}>
              <span className="menu-icon">
                <Icon name={item.icon} />
              </span>
              <span className="menu-text">{item.label}</span>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export { AppMenu }
